// ── src/pages/KycReviewPage.jsx ────────────────────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import adminApi from '../api/adminApi';
import { Button } from 'antd';
import { DetailList, SectionCard, StatusTag, fmtDateTime, useFlatPage } from '../components/ui';

export default function KycReviewPage() {
  useFlatPage();
  const { userId }  = useParams();      // e.g. /kyc-review/123
  const  navigate   = useNavigate();

  const [user ,   setUser ]   = useState(null);
  const [error,   setError]   = useState(null);
  const [loading, setLoading] = useState(true);

  /* ──────────────────────────────────────────────────────────
     1. Validate the route param & fetch user data **after**
        the first render.  No navigation inside render. */
  useEffect(() => {
    // If the route is wrong, redirect once *after* mount
    if (!userId) {
      navigate('/admin/dashboard', { replace: true });
      return;
    }

    // Abort‑controller so we don’t try to setState after unmount
    const ctrl = new AbortController();

    (async () => {
      try {
        const { data } = await adminApi.getUserById(userId, {
          signal: ctrl.signal
        });
        setUser(data);
      } catch (err) {
        if (ctrl.signal.aborted) return;       // silent abort
        const msg =
          err.response?.data?.message ||
          'Failed to fetch user details.';
        setError(msg);
      } finally {
        setLoading(false);
      }
    })();

    // cleanup
    return () => ctrl.abort();
  }, [userId, navigate]);

  /* ──────────────────────────────────────────────────────────
     2. UI states */
  if (loading)  return <div className="hms-page"><div className="hms-empty">Loading…</div></div>;
  if (error)    return <div className="hms-page"><div className="hms-empty">{error}</div></div>;
  if (!user)    return null; // should not happen but keeps TS/IDE happy

  /* ──────────────────────────────────────�
     3. Happy path */
  return (
    <div className="hms-page">
      <div className="hms-page-header">
        <div className="hms-actions">
          <Button onClick={() => navigate('/admin/dashboard')}>Back to dashboard</Button>
        </div>
      </div>

      <SectionCard title={`KYC review: ${user.firstName} ${user.lastName}`}>
        <DetailList
          items={[
            { label: 'Email', value: user.email },
            { label: 'KYC status', value: user.kycStatus ? <StatusTag status={String(user.kycStatus)}>{user.kycStatus}</StatusTag> : null },
            { label: 'Submitted', value: user.kycSubmittedAt ? fmtDateTime(user.kycSubmittedAt) : null },
          ]}
        />
      </SectionCard>
    </div>
  );
}
